import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { EmptyState } from "../../components/ui/EmptyState";

export function ClientGlossaryPage() {
  return (
    <div>
      <AdminPageHeader
        eyebrow="Client portal"
        title="Glossary"
        description="Coaching terms and exercise help will appear here."
      />
      <EmptyState title="Glossary help is not built yet.">
        Your assigned meal and workout plans are available from the client dashboard.
      </EmptyState>
    </div>
  );
}
